import View from '../Support/View/View';

export default class Collapse extends View {
    #toggler = null;
    #isOpen  = false;

    static get viewName() {
        return 'collapse';
    }
    static get viewType() {
        return 'component';
    }

    start() {
        if (!this.isLegacyBrowser) {
            return;
        }

        this.#setInitialOpenState();
        this.#setToggler();

        this.addEventHandler('click', this.#onTogglerClick.bind(this));
    }

    #setInitialOpenState() {
        this.#isOpen = this.$el.hasAttribute('open');
    }

    #setToggler() {
        this.#toggler = this.$el.firstElementChild;
    }

    #onTogglerClick(e) {
        if (!e.target?.isSameNode(this.#toggler)) {
            return;
        }

        e.preventDefault();

        this.#isOpen = !this.#isOpen;

        if (this.#isOpen) {
            this.$el.setAttribute('open', 'open');
        } else {
            this.$el.removeAttribute('open');
        }
    }
}